export default "__VITE_ASSET___Z8D1aZQ__"